module.exports = __webpack_public_path__ + "img/game10.2ca79e09.png";